import styled, { keyframes } from 'styled-components';

import { BREAKPOINTS, colors } from 'common/styles/style-constants';

import { Title } from '../styled-components';

export const MessageLine = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 10px;
`;

export const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-evenly;
`;

export const Checkmark = styled.div`
  display: inline-block;
  transform: rotate(45deg);
  height: 24px;
  width: 12px;
  border-bottom: 5px solid ${colors.forestGreen};
  border-right: 5px solid ${colors.forestGreen};
  margin: 0 12px;
`;

export const Container = styled(Title)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  white-space: nowrap;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    font-size: 14px;
  }
`;

export const EmptyCircle = styled.div`
  display: inline-block;

  width: 20px;
  height: 20px;
  margin: 0 8px;

  border: 3px solid #d2dce3;
  border-radius: 50%;
`;

const loadingCircleAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const LoadingCircle = styled(EmptyCircle)`
  border-color: ${colors.blue} ${colors.blue} ${colors.blue} transparent;
  animation: ${loadingCircleAnimation} 1s linear infinite;
`;
